import React, { useState, useEffect } from "react";
import { getUserSSO, updateTenantByUser } from '../../apirapper/user.ts';
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from 'react-redux';
// import { useDispatch } from "react-redux";
// import { setFullName } from "../../core/redux/action";
import { bucketObj } from "../../environment";
import {uploadImageNew} from "../../core/img/imagewithbasebath";
import imageCompression from 'browser-image-compression'; 
import { getUrls } from '../../api/apiurls.js';
// import { messaging } from "../../utils/firebaseUtils";

const TenantSettings = () => {
  const MySwal = withReactContent(Swal);
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  // const dispatch = useDispatch();
  const [userData, setUserData] = useState({
    _id: "",
    email: "",
    customUrl: "",
    displayName: "",
    logoUrl: "",
    coverImageUrl:""
    //add urls
  });
  const [loading, setLoading] = useState(true);
  //Permissions  
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'profile' && p.Permission.toLowerCase() === 'view');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'profile' && p.Permission.toLowerCase() === 'update');


  const [errors, setErrors] = useState({});
  // const [errorsPass, setErrorsPass] = useState({});
   
  const handleImageUpload = async(event, type) => {
    try {
        if(event.target.files.length) {
            const file = event.target.files[0];
            // Check the file size
            if (file.size > 5242880) {//5mb
                alert(t?.[l]?.["file_size_exceeds_5_mb_limit"] || "File size exceeds 5 MB limit");
                event.target.value = ''; // Clear the file input
                return;
            }

            // Image compression options
            const options = {
                maxSizeMB: 2, // Adjust the max size as needed
                maxWidthOrHeight: 500, // Adjust dimensions as needed
                useWebWorker: true
            };
            const compressedFile = await imageCompression(file, options);
            let name = await uploadImageNew(compressedFile,'settings','img');
            event.target.value = '';
            console.log('name',name);
                
            if (file && file.type.startsWith('image/')) {
                setUserData((prev) => ({
                    ...prev,
                    [type]: name,
                }));
            } else {
                alert('Please upload a valid image file.');
            }

        }
    } catch (error) {
        console.error('Error compressing image:', error);
    }
};

const handleDrop = async (event, type) => {
    event.preventDefault();

    try {
        if(event.dataTransfer.files.length) {
            const file = event.dataTransfer.files[0];
            // Check the file size
            if (file.size > 5242880) {//5mb
                alert(t?.[l]?.["file_size_exceeds_5_mb_limit"] || "File size exceeds 5 MB limit");
                event.target.value = ''; // Clear the file input
                return;
            }

            // Image compression options
            const options = {
                maxSizeMB: 1, // Adjust the max size as needed
                maxWidthOrHeight: 500, // Adjust dimensions as needed
                useWebWorker: true
            };
            const compressedFile = await imageCompression(file, options);
            let name = await uploadImageNew(compressedFile,'settings','img');
            event.target.value = '';
            console.log('name',name);
                
            if (file && file.type.startsWith('image/')) {
                setUserData((prev) => ({
                    ...prev,
                    [type]: name,
                }));
            } else {
                alert('Please upload a valid image file.');
            }

        }
    } catch (error) {
        console.error('Error compressing image:', error);
    }
};

const renderImagePreview = (type) => {
    //bucketObj.bucketUrl+bucketObj.objectKey+imageData
    if (userData[type]) {
        if(userData[type] == "deleted")
        {
            return null;
        }
        var imageUrl = "";
        if(type == 'logoUrl')
            imageUrl = bucketObj.bucketUrl+bucketObj.objectKey+userData.logoUrl;//URL.createObjectURL(userData[type]);
        else
            imageUrl = bucketObj.bucketUrl+bucketObj.objectKey+userData.coverImageUrl;//URL.createObjectURL(userData[type]);
        
        return (
            <>
            <img
                src={imageUrl}
                alt={type}
                className="img-fluid-phone-img"
                // className="img-fluid"
                style={{ maxWidth: "100%",maxHeight: "80%" }}
            />
            <button
            type="button"
            className="btn btn-danger position-absolute"
            style={{
                top: 'calc(37% - 15px)', // Adjusts position based on image height
                right: 'calc(11% - 15px)', // Adjusts position based on image width
              borderRadius: '50%',
              width: '17px',
              height: '17px',
              padding: '0',
              lineHeight: '1',
              zIndex: 10, // Ensure it's on top of the image
            }}

            onClick={(e) => {
              e.stopPropagation(); // Prevent click from bubbling up
              setUserData((prev) => ({
                ...prev,
                [type]: "deleted",
            }));
            
            }}
          >
            &times; {/* Cross symbol */}
          </button>
          </>
        );
    }
    return null;
};

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await getUserSSO();
        
        console.log('response', response.response.userDetails.profile);
        const userDetails = response.response.userDetails;
        const tenantDetails = userDetails.tenant;

        console.log('tenantDetails',tenantDetails);
        // const profile = userDetails.profile;
        // Update state with user data

        setUserData({
          // firstName: profile.firstName,
          // lastName: profile.lastName,
          _id: tenantDetails._id,
          email: userDetails.email,
          coverImageUrl: tenantDetails.coverImageUrl,
          customUrl: tenantDetails.customUrl,
          displayName: tenantDetails.displayName,
          logoUrl: tenantDetails.logoUrl,
        });
        
      } catch (error) {
        console.error('Error fetching user data', error);
      } finally{
        setLoading(false)
      }
    };

    fetchUserData();
  }, []);



  const validateProfile = () => {
    const errors = {};
    // if (!userData.firstName) {
    //   errors.firstName = "Please add a first name.";
    // }
    // if (!userData.lastName) {
    //   errors.lastName = "Please add a last name.";
    // }
    if (!userData.displayName) {
      errors.displayName = "Please add  display name.";
    }
  
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    if (validateProfile()) {
      try {
        delete userData.email;
        // userData.device = fcmToken
      
        if(userData.customUrl == "")
          delete userData.customUrl

        const response = await updateTenantByUser(userData); 
        // var fullName = userData.firstName || undefined;
				// if(userData.lastName){
				// 	fullName = userData.firstName+' '+userData.lastName;
				// }
        // dispatch(setFullName(fullName));
        // localStorage.setItem('fullName',fullName);
        
        if(response)
          {
            MySwal.fire({
              position: "top-end",
              icon: "success",
              title: t?.[l]?.["profile_updated_successfully!"] || "Profile updated successfully!",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        // Show a success message or toaster
      } catch (error) {
        console.error('Error updating profile', error);
        setErrors({ general: 'Failed to update profile.' });
      }
    }
  };
  const validateCustomUrl = (url, event) => {
    if(url == "") return true;
    // Allow backspace (keyCode 8) and tab (keyCode 9)
    if (event && (event.keyCode === 8 || event.keyCode === 9)) {
        return true;
    }
    
    // Regular expression to validate the custom URL
    const urlRegex = /^[a-zA-Z0-9-]+$/;
    return urlRegex.test(url);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "customUrl" && !validateCustomUrl(value)) {
    const please_enter_a_valid_url = t[l]?.please_enter_a_valid_url || "Please enter a valid URL (letters, numbers, hyphens only).";
        setErrors({ ...errors, [name]: please_enter_a_valid_url});
        return;
    }
    setUserData({ ...userData, [name]: value });
    setErrors({ ...errors, [name]: "" }); 
  };

  if (loading) {
    return (
      <div className="page-wrapper dashboard-wrapper">
        <div className="dashboard-content loader-content">
          <div id="global-loader">
            <div className="whirly-loader"></div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
       {canView ? (
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-top">
              </div>
            </div>
            <div className="input-blocks">
              <h3> {t[l]?.["my_profile"] || 'My Profile'}</h3>
              <hr/>
            </div>
            <div className="row">
        
              <div className="row">
               
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">{t[l]?.["display_name"] || 'Display Name'}</label>
                    <input
                      type="text"
                      placeholder={t[l]?.["display_name"] || 'Display Name'}
                      className="form-control"
                      value={userData.displayName}
                      required="required"
                      onChange={(e) => setUserData({ ...userData, displayName: e.target.value })}
                    />
                    {errors.displayName && (
                      <span className="text-danger">{errors.displayName}</span>
                    )}
                  </div>
                </div> 
          
                
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                      <label className="form-label">
                          {t?.[l]?.["custom_url"] || "Custom Url"}
                      </label>
                      <input
                          type="text"
                          placeholder={t?.[l]?.["custom_url"] || "Custom Url"} 
                          className={`form-control ${errors.customUrl ? 'is-invalid' : ''}`}
                          value={userData?.customUrl || ""}
                          name="customUrl"  
                          maxLength={50}
                          onChange={handleInputChange}
                      />
                      
                      {userData?._id && (
                        <small>{t?.[l]?.["default"] || "Default"}: <b>
                          {getUrls().ecomUrl}company/{userData._id}</b>
                       </small>
                      )}<br />
                                             {userData?.customUrl && (
                          <small>
                                {t?.[l]?.["preview"] || "Preview"}: <b>
                              {getUrls().ecomUrl}company/{userData.customUrl}</b>
                          </small>
                      )}
                       {errors.customUrl && <div className="invalid-feedback">{errors.customUrl}</div>}
                  </div>
              </div>
                {/* <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label>{t[l]?.["email"] || 'Email'}</label>
                    <input
                      type="email"
                      className="form-control"
                      value={userData.email}
                      required="required"
                      disabled
                    />
                    {errors.email && (
                      <span className="text-danger">{errors.email}</span>
                    )}
                  </div>
                </div> */}
                <div className="col-6 mb-3">
                      <label className="form-label">{t?.[l]?.["upload_logo"] || "Upload Logo"}</label>
                      <div
                          className="image-upload p-4 text-center position-relative"
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => handleDrop(e, 'logoUrl')}
                          onClick={() => document.getElementById('logoInput').click()}
                          style={{ height: '200px' }} // Set height for the logo box
                      >
                          
                          <input
                              id="logoInput"
                              type="file"
                              className="d-none"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, 'logoUrl')}
                          />
                          <p>{t?.[l]?.["drag_&_drop_or_click_to_upload"] || "Drag & drop or click to upload"}</p>
                          {renderImagePreview('logoUrl')}
                          </div>
                  </div>
                  <div className="col-6 mb-3">
                      <label className="form-label">{t?.[l]?.["upload_cover"] || "Upload Cover"}</label>
                      <div
                          className="image-upload p-4 text-center position-relative"
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => handleDrop(e, 'coverImageUrl')}
                          onClick={() => document.getElementById('coverInput').click()}
                          style={{ height: '200px' }} // Set height for the cover box
                      >
                          <input
                              id="coverInput"
                              type="file"
                              className="d-none"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, 'coverImageUrl')}
                          />
                          <p>{t?.[l]?.["drag_&_drop_or_click_to_upload"] || "Drag & drop or click to upload"}</p>
                          {renderImagePreview('coverImageUrl')}
                      </div>
                  </div>
                  {/* <div className="row">
                  <div className="col-10"></div>
                  <div className="col-2 text-end">
                  { canUpdate&&(
                    <Link onClick={handleSaveProfile} className="btn btn-submit me-2">
                    {t[l]?.["save_changes"] || 'Save Changes'}
                    </Link>) 
                    }
                  </div>
                </div> */}
                <div className="text-end">
                
                    {canUpdate && (
                      <Link onClick={handleSaveProfile} className="btn btn-submit">
                        {t[l]?.["save_changes"] || 'Save Changes'}
                      </Link>
                    )}
                 
                </div>
              </div>
            <div className="col-lg-4">
              {/* Image upload section with drag and drop */}
              <div className="row">
                 
              </div>
            </div>
            </div>
          </div>

    
        </div>
      </div>
       ):(
       <div className="content">
        <p>{t[l]?.["no_permission"] || "You do not have permission to view this page."}</p>
       </div>)}
    </div>
  );
};

export default TenantSettings;